module.exports = __webpack_public_path__ + "static/media/298358.f788d96b.png";